import { render, staticRenderFns } from "./BDivider.vue?vue&type=template&id=9b0afd82&"
import script from "./BDivider.vue?vue&type=script&lang=js&"
export * from "./BDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports